
import { FC } from "react";
import { useStreak } from "./StreakContextType";
import { StreakCounterProps } from "../component/StreakTypes";

export const StreakCounter: FC<StreakCounterProps> = ({ className, style }) => {
  const { days, themeManager } = useStreak();

  return (
    <div className={`q_steak_days_box ${className || ""}`} style={style}>
      <div
        className="q_streak_days"
        style={themeManager.getStreakCountStyles()}
      >
        {days}
      </div>
      <div
        className="q_steak_days_text"
        style={themeManager.getStreakHeadingStyles()}
      >
        Streak days
      </div>
    </div>
  );
};
 